import axios from 'axios';
import { Message } from 'element-ui'
import qs from 'qs'
import util from '@/util/util'
import baseURL from '@/config/host'

const http = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    'Content-Type':  'application/json',
    'Access-Control-Allow-Origin': '*',
    device: 'web',
    devicemodel: navigator.userAgent
  },
  transformRequest: [function(data){
    return JSON.stringify(data)
  }]
})

http.interceptors.request.use( request => {
  //确保每次请求都是最新的登录秘钥
  request.headers.Authorization = 'Bearer ' + util.getCookie('auth')
  return request
})

http.interceptors.response.use( response => {

  if(response.status == 200){
    if(response.data.code == 1 || response.data.code == 200){
      return response.data.res
    } else {
      if(response.data.code == 10007){
        Message({type: 'info', message: '请重新登录'})
        location.href = '#/login'
        return
      }
      // else if(response.data.code == 2){
      //   Message({type: 'error', message: "设备不在线"});
      //   return
      // }else if(response.data.code == 0){
      //   Message({type: 'error', message: "更新失败"});
      //   return
      // }

      return Promise.reject(response.data)
    }
  } else {
    Message({type: 'error', message: response.status})
  }
})



export default http;



// WEBPACK FOOTER //
// ./src/http/index.js